/**
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "MW/toolstrip/constants/TypeConstants"
], function (declare, TypeConstants) {

    var SUPPORTED_VALUES = ["Horizontal", "Vertical"];

    return declare(null, {

        /**
         * @property {string} orientation - Value must be either "Horizontal" or "Vertical"
         * @instance
         * @default
         */
        orientation: "Horizontal",
        horizontalHeight: 22,
        verticalHeight: 72,

        _setOrientationAttr: function (orientation) {

            if (SUPPORTED_VALUES.indexOf(orientation) === -1) {
                throw new Error("'orientation' property expects one of these values: " + SUPPORTED_VALUES);
            }

            // The order matters here

            //Remove old class, add new class
            this.domNode.classList.remove(this._getClassNameForOrientation(this.get("orientation")));

            this.domNode.classList.add(this._getClassNameForOrientation(orientation));

            if (orientation === "Horizontal") {
                this.set("iconProp", "quickAccessIcon"); // If we made all icons query-able with orientation-icon type format, could remove
                this.set("iconAlignment", "left");
            } else if (orientation === "Vertical") {
                this.set("iconProp", "icon");
                this.set("iconAlignment", "top");
            }

            this._set("orientation", orientation);
            if (this._started) { // To make sure widget is attached to the DOM
                this._checkAndFixClippedText();
            }
        },

        _getClassNameForOrientation: function (orientation) {
            // Don't need "orientation.charAt(0).toUpperCase() + orientation.slice(1)" since supported values are capitalized
            return "mw" + orientation + "Orientation";
        },

        startup: function () {
            this.inherited(arguments);
            this._checkAndFixClippedText();
        },

        _isWidthSetOnColumn: function () {
            var parent;
            if (this.getParent) {
                parent = this.getParent();
            }

            return parent && parent.get("type") === TypeConstants.COLUMN && parent.get("width") > 0;
        },

        // TODO: This whole logic to check and fix clipped text seems too fragile. Investigate and reassess this usecase
        // in the future to replace it with a more stable solution moving forward.
        /**
         * g2037662: Having a fixed width on the column might cause a part of the widget's text to get clipped off
         * when its orientation is Vertical. This function checks for such possibility and fixes the clipped text.
         * @private
         */
        _checkAndFixClippedText: function () {
            if (this._isWidthSetOnColumn() && (this.get("type") === TypeConstants.PUSH_BUTTON || this.get("type") === TypeConstants.TOGGLE_BUTTON)) {
                var textClippingClassExists = false;
                if (this.textNode && this.textNode.classList.contains("avoidTextClipping")) {
                    textClippingClassExists = true;

                    // Remove the avoidTextClipping class first so that we can do the below calculations to check if the
                    // text will get clipped or not.
                    this.textNode.classList.remove("avoidTextClipping");
                }


                if (this.get("orientation") === "Vertical" && this.textNode) {
                    var text = this.textNode.getAttribute("data-text-content");

                    // The whitespace style is set to "pre-line" for PushButton and ToggleButton which moves the text after a
                    // whitespace to the next line. Since, PushButton and ToggleButton only support 2 lines, having two or
                    // more whitespaces in the text spans it across more than 2 lines if the column width is not wide
                    // enough which causes the text to get clipped.
                    if (text && text.trim().split(" ").length - 1 > 1) {
                        if (this.contentWrapperNode && this.domNode) {
                            var contentWrapperNodeStyles = window.getComputedStyle(this.contentWrapperNode);
                            var domNodeStyles = window.getComputedStyle(this.domNode);

                            if (isNaN(parseFloat(contentWrapperNodeStyles.height))) {
                                // While resizing toolstrip, there is an intermediate state where
                                // window.getComputedStyle returns "auto" for contentWrapperNode's height. As a
                                // result, parseFloat("auto") returns NaN and we might not add the
                                // "avoidTextClipping" class when it is actually necessary. As a countermeasure, we
                                // save the original state of the widget in a variable "textClippingClassExists" so
                                // that we know whether the class was added before or not and just keep the same
                                // state here because we are not expecting resize to change the column width. Also,
                                // currently there is no way to remove the width of the column once you set a width
                                // on it (you can only change the width using a positive integer but not remove it).
                                // This might work in our favor as we do not need to worry about removing the class,
                                // thinking that a user might remove the width on the column.
                                if (textClippingClassExists) {
                                    this.textNode.classList.add("avoidTextClipping");
                                }
                            } else {
                                // When the text gets clipped off, contentWrapperNode's height gets more than the DOM node's height.
                                if (parseFloat(contentWrapperNodeStyles.height) > parseFloat(domNodeStyles.height)) {
                                    // Change the whiteSpace style of the textNode using avoidTextClipping class so that the column
                                    // gets expanded automatically above its specified width.
                                    this.textNode.classList.add("avoidTextClipping");
                                }
                            }
                        }
                    }
                }
            }
        }
    });
});
